module.exports = __webpack_public_path__ + "static/media/online-class.7c346596.svg";